import styled from 'styled-components';

const StyledForm = styled.form`
    text-align: center;
    max-width: 700px;
    margin: 0 auto;

    pre {
        color: ${p => p.theme.palette.text.primary};
        opacity: 0.8;
    }
`;

const FieldWrap = styled.div`
    position: relative;
    margin: 1em 0;

    textarea {
        resize: vertical;
    }
`;

const GroupWrap = styled.div`
    margin: 0.25em 0;

    &.horizontal {
        text-align: left;
        display: inline-block;
        vertical-align: top;
        width: ${p => `${p.width}%` || 'auto'};
    }
`;

const ButtonWrap = styled.div`
    clear: both;
    margin: 4em 0.2em 2em;

    .privacy-link {
        text-align: center;
        font-size: 0.82em;
        margin-top: 0.4em;
    }

    .loadingWrap {
        margin: 2em;
        img {
            height: 50px;
        }
    }

    .successWrap {
        margin: 2em 0;
        color: ${p => p.theme.palette.text.primary};
        font-family: ${p => p.theme.fonts.brutal.regular};

        h3.error {
            color: red;
            font-size: 16px;
            line-height: 1.3em;
        }

        a {
            color: inherit;
        }
    }

    .icon-checkmark {
        color: ${p => p.theme.palette.success.dark};
        padding-left: 1em;
    }
`;

const GroupTitle = styled.h4`
    text-align: left;
    color: ${p => p.theme.palette.text.primary};
    margin: 2.75em 0 1em;
    font-family: ${p => p.theme.fonts.brutal.light};
    font-size: 1em;
`;

const Disclaimer = styled.div`
    line-height: 1.5em;
    margin: 0.5em auto 1em;
    font-size: 14px;
    width: 80%;
`;

export {StyledForm, GroupTitle, ButtonWrap, GroupWrap, FieldWrap, Disclaimer};
